import React, { useEffect, useState, useContext } from 'react';
import UserContext from '../context/UserContext';
import { api } from '../utils/apiHelper';
import '../styles/AdSectBeatBattle.css';

const AdSectBeatBattle = () => {
   const { authUser } = useContext(UserContext);
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBeatBattleSubmissions = async () => {
      try {
        const res = await api('/get-beatbattle-submissions', 'GET');
        if (res && Array.isArray(res.submissions)) {
          console.log(res.submissions);
          setSubmissions(res.submissions);
        }
      } catch (err) {
        console.error('Error fetching Beat Battle submissions:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBeatBattleSubmissions();
  }, []);

  if (loading) {
    return <p>Loading Beat Battle submissions...</p>;
  }

  return (
    <div className="adsect-container">
      <h3>Beat Battle Submissions</h3>
      {submissions.length === 0 ? (
        <p>No Beat Battle submissions found.</p>
      ) : (
        <ul className="beatbattle-list">
          {submissions.map((bb) => (
            <li key={bb._id} className="beatbattle-item">
              <strong>{bb.projectTitle}</strong> by {bb.producerName}<br />
              <em>{bb.email}</em><br />

              {bb.files && bb.files.map((file) => (
                file.type?.startsWith('image/') ? (
                  <img
                    key={file.fileId}
                    src={file.url}
                    alt={file.fileName}
                    className="beatbattle-image"
                  />
                ) : file.type?.startsWith('audio/') ? (
                  <audio key={file.fileId} controls className="beatbattle-audio">
                    <source src={file.url} type={file.type} />
                    Your browser does not support the audio element.
                  </audio>
                ) : null
              ))}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdSectBeatBattle;
